// removed by extract-text-webpack-plugin
module.exports = {"buttonLink":"_123dIVmZIjFXA_RusAWEGO","envLabel":"_3aKJ23BYFJmBGmG5NXUBm5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/style.scss
// module id = 793
// module chunks = 1